<template>
    <a-card title="财务信息">
        <a-form ref="ruleForm" :model="form" :rules="rules" :isModal="false">
            <!--可编辑区域 start-->
            <a-row :gutter="24">
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id" />
                    </a-form-item>
                    <a-form-item label="companyCode" name="companyCode">
                        <a-input v-model:value="form.companyCode" />
                    </a-form-item>
                </div>
                <a-col :span="12">
                    <a-form-item label="开户银行（基本户）" name="bankName">
                        <a-input v-model:value="form.bankName" placeholder="请输入开户许可证中开户银行的全称" />
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="开户银行账号" name="bankAccount">
                        <a-input v-model:value="form.bankAccount" placeholder="请输入开户银行账号" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="开户银行行号" name="bankCode">
                        <a-input v-model:value="form.bankCode" placeholder="请输入开户银行行号" />
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="财务联系人" name="bankContacts">
                        <a-input v-model:value="form.bankContacts" style="width: 100%" placeholder="请输入财务联系人" />
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="财务联系电话" name="bankPhone">
                        <a-input v-model:value="form.bankPhone" placeholder="请输入财务联系电话" />
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="统一纳税人识别号" name="taxRegistrationNumber">
                        <a-input :disabled="true" v-model:value="form.taxRegistrationNumber" placeholder="请输入统一纳税人识别号" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="开户行许可证(PDF格式)" name="bankPermitFile">
                        <file-upload v-model:value="form.bankPermitFile" :size="50" :isPdf="true" />
                    </a-form-item>
                </a-col>
                <a-col span="24">
                    <a-form-item :wrapper-col="{ offset: 8, span: 16 }">
                        <a-button type="primary" html-type="submit" @click="onSubmit">
                            提交
                        </a-button>
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>
    </a-card>
</template>
<script>
import { formMixin } from "@/mixins";
import { finance, companyInfo } from "@/api/companyService";
import dataCheck from "@/utils/dataCheck";

export default {
    name: "companyInfo",
    components: {},
    mixins: [formMixin],
    data() {
        return {
            isFinance: true,
            form: {
                id: null,
                bankName: null,
                bankAccount: null,
                bankCode: null,
                bankContacts: null,
                bankPhone: null,
                taxRegistrationNumber: null,
                companyCode: this.$ls.get("companyCode")

            },
            rules: {
                id: [],
                bankName: [dataCheck.required({})],
                bankAccount: [dataCheck.required({})],
                bankCode: [dataCheck.required({})],
                bankContacts: [dataCheck.required({})],
                bankPhone: [dataCheck.required({}), dataCheck.mobile_phone],
                taxRegistrationNumber: [dataCheck.required({})],
                bankPermitFile: [dataCheck.required({})],
                companyCode: []
            },
            submitUrl: finance.saveOrUpdate
        }
    },
    created() {
        // this.getCompanyInfo()
        this.getCorpInfo()
    },
    methods: {

        getCorpInfo() {
            this.getAction({
                url: finance.detail,
                params: {
                    companyCode: this.$ls.get("companyCode")
                }
            }).then(res => {
                this.getAction({
                    url: companyInfo.detail
                }).then(r => {
                    let obj = {
                        ...res,
                        taxRegistrationNumber: r.oraganizationCode
                    }
                    this.form = obj
                })

            })
        },
    },
}
</script>
<style lang="less" scoped></style>
